<template>
  <div class="flex items-center gap-3 px-3 py-2 rounded-md bg-secondary text-white lg:whitespace-nowrap text-sm">
    <TIcon
      :icon="['fas', 'leaf-maple']"
      class="w-5 h-5 text-orange-400"
    />
    <div class="lg:flex lg:items-center lg:gap-3">
      <div class="font-semibold">
        {{ t('highlight') }}
      </div>
      <div>{{ t('description') }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()
</script>

<i18n lang="json">
{
  "en": {
    "highlight": "Fall getaways!",
    "description": "Cozy up this Thanksgiving weekend!"
  },
  "fr": {
    "highlight": "Escapade automnale !",
    "description": "Passez cette action de grâce à l’aise !"
  }
}
</i18n>
